import Spinner from 'react-spinkit'

const LoadingSpinner = () => (
  <div className="u-inline-block">
    <Spinner fadeIn="none" name="line-scale" color="#5017f4" />
  </div>
)

export default LoadingSpinner
